import React from "react";
import { context, useAuth } from "../context/authContext";




export default function Navbar() {
  const { user, logout, loading } = useAuth();
  return (
    <div>
      <nav className="bg-blue-500 p-4 flex items-center justify-between">
        <div>
          <h1 className="text-white text-xl font-semibold">
            DrawingsMachines{" "}
          </h1>
        </div>
        <div className="flex items-center space-x-4">
          <span className="text-white">
            Bienvenido {user.displayName || user.email}
          </span>
          <i className="fas fa-user-circle text-white text-2xl" />
        </div>
      </nav>
    </div>
  );
}
